<!-- Table -->
<div *ngIf="groupLoaded && !isgroupreporting" class="group-reporting-disabled">Group Reporting is disabled for {{prfNumber}}
</div>
<table *ngIf="groupLoaded && isgroupreporting" class="table">
  <thead>
    <tr>
      <th>#</th>
      <th>PDB Number</th>
      <th>Company</th>
      <th>NAIC</th>
      <th>AMBest</th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let item of groupreportingIncludedList; let i = index">

      <td>{{ i + 1 }}</td>

      <td>{{ item.No }}</td>

      <td>{{ item.Name }}</td>

      <!-- NAIC -->
      <td>{{ item.NAIC || '-' }}</td>
      <td>{{item.AMBest || '-'}}</td>
    </tr>
  </tbody>
</table>